// extracted by mini-css-extract-plugin
export default {"gallery":"c-m_ha","gallery__header":"c-m_hb","gallery__thumbs":"c-m_hc"};